const menu = [];

const abcUsage = false;

const language = 'fr';

const googleApiKey = null;

const token = null;

const sessionGuid = null;

const expandedTimesheet = false;

export const appGoParam =
{
    menu,
    abcUsage,
    language,
    googleApiKey,
    token,
    sessionGuid,
    expandedTimesheet
}